/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_Normal_HintInputs */

const en_us2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A working set: counts toward volume, records and progression.`)
};

const pt_br2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de trabalho: conta no volume, nos recordes e na progressão.`)
};

const es_419_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie de trabajo: cuenta para el volumen, los récords y la progresión.`)
};

const pt_pt2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de trabalho: conta para o volume, os recordes e a progressão.`)
};

const fr_fr2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de travail : compte dans le volume, les records et la progression.`)
};

const de_de2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Arbeitssatz: zählt für Volumen, Rekorde und Progression.`)
};

const it_it2_workout_logging_kind_normal_hint = /** @type {(inputs: Workout_Logging_Kind_Normal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una serie allenante: conta per volume, record e progressione.`)
};

/**
* | output |
* | --- |
* | "A working set: counts toward volume, records and progression." |
*
* @param {Workout_Logging_Kind_Normal_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_normal_hint = /** @type {((inputs?: Workout_Logging_Kind_Normal_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_Normal_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_normal_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_normal_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_normal_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_normal_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_normal_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_normal_hint(inputs)
	return en_us2_workout_logging_kind_normal_hint(inputs)
});
export { workout_logging_kind_normal_hint as "workout-logging.kind_normal_hint" }